import React, {useContext} from 'react';
import './CSS/ShopCategory.css';
import {ShopContext} from "../Context/ShopContext";
import Description_ShopCategory from '../Components/Assets/Description_ShopCategory';
import Baner from "../Components/Baner/Baner";
import Item from "../Components/Item/Item";
import { useTranslation } from 'react-i18next';

const ShopCategory = (props) => {

    const { t } = useTranslation();
    const {all_product} = useContext(ShopContext);
    const categoryData = Description_ShopCategory.find(item => item.category === props.category);

    return (
        <section className='shop-category'>
            <div className='content-wrap'>
                <div className='baner-shop-category d-flex'>
                    {categoryData && (
                        <Baner image={categoryData.images} description={t(categoryData.description)}/>
                    )}
                </div>

                <div className='shopcategory-products d-flex'>
                    {all_product.map((item, i) => {
                        if (props.category === item.category) {
                            return <Item key={i} id={item.id} name={t(item.name)} image={item.images?.[0]}
                                         new_price={item.new_price} old_price={item.old_price}
                                         description={t(item.description)} category={item.category}/>
                        } else {
                            return null;
                        }
                    })}
                </div>
            </div>
        </section>
    )
}

export default ShopCategory;
